import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useDemoMode(familyId: string | undefined) {
  const { data: isDemoActive, isLoading } = useQuery({
    queryKey: ['demo-mode', familyId],
    queryFn: async () => {
      if (!familyId) return false;
      
      const { data, error } = await supabase
        .from('families')
        .select('demo_content_active')
        .eq('id', familyId)
        .single();
      
      if (error) {
        console.error('Error fetching demo mode:', error);
        // Fallback to localStorage
        return localStorage.getItem(`family-${familyId}-demo-mode`) === 'true';
      }
      
      return data?.demo_content_active ?? false;
    },
    enabled: !!familyId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    isDemoActive: isDemoActive ?? false,
    isLoading,
  };
}
